/**
 * Initial state
 * @type {Object}
 */
const state = {
  /**
   * 配置选项
   * @type {Object}
   */
  // dialogVisible: false,
  equipmentModel: {
    brands: '',
    dModel: '',
    code: '',
    organizeName: '',
    organizeId: 0,
    devicestate: '1',
    title: '',
    serial: '',
    about: '',
    modelid: 0
  },
  deviceModel: {
    title: '',
    serial: '',
    tagCode: '',
    about: '',
    devicestate: '1',
    equipmentId: 0,
    equipmentCode: ''
  },
  triggerModel: {
    column: 'temperature',
    item: '1',
    value: '',
    aid: [],
    etype: '1',
    count: '2',
    rangeweek: ['1', '2', '3', '4', '5', '6', '7'],
    rangetime: [0, 48],
    enabled: '1',
    content: '您的设备{c}，在{t}时 温度 为{v}出现异常',
    dataitem: '',
    serial: '',
    title: '',
    disabletriggeritem: false,
    disabletriggervalue: false,
    operatingitem: 0,
    id: 0
  },
  triggerDeviceModel: {
    serial: '',
    title: '',
    dataitem: ''
  }
}

/**
 * Getters
 * @type {Object}
 */
const getters = {
  /**
   * 获取配置选项
   * @param  {Object} state Vuex状态对象
   * @return {Object}       配置选项
   */
  // dialogVisible: state => state.dialogVisible,
  deviceModel: state => state.deviceModel,
  triggerModel: state => state.triggerModel,
  triggerDeviceModel: state => state.triggerDeviceModel,
  equipmentModel: state => state.equipmentModel
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {
  /**
   * 设置配置选项
   * @param  {Object} state   Vuex状态对象
   * @param  {Object} value 新的配置选项
   */
  // CHANGE_DIALOGVISIBLE: (state, value) => {
  //   state.dialogVisible = value
  // },
  Device_New_Model2: (state) => {
    state.equipmentModel = {
      brands: '',
      dModel: '',
      code: '',
      organizeName: '',
      organizeId: 0,
      devicestate: '1',
      title: '',
      serial: '',
      about: ''
    }
  },
  Device_New_Model: (state, value) => {
    state.deviceModel = {
      title: '',
      serial: '',
      tagCode: '',
      about: '',
      devicestate: '1',
      equipmentId: 0,
      equipmentCode: value.title
    }
    if (value.title !== 'new') {
      state.deviceModel.title = value.title + '-'
    }
    state.deviceModel.equipmentId = value.equipid
  },
  Device_Edit_Model: (state, value) => {
    state.deviceModel.MaxValue = value.MaxValue
    state.deviceModel.MinValue = value.MinValue
    state.deviceModel.title = value.title
    state.deviceModel.serial = value.Serial
    state.deviceModel.equipmentCode = value.equipmentCode
  },
  Trigger_New_Model: (state, value) => {
    state.triggerModel = {
      column: 'temperature',
      item: '1',
      value: '',
      aid: [],
      etype: '1',
      count: '2',
      rangeweek: ['1', '2', '3', '4', '5', '6', '7'],
      rangetime: [0, 48],
      enabled: '1',
      content: '您的设备{c}，在{t}时 温度 为{v}出现异常',
      dataitem: '',
      serial: '',
      title: '',
      disabletriggeritem: false,
      disabletriggervalue: false,
      operatingitem: 0,
      id: 0
    }
    state.triggerModel.operatingitem = value.index
    state.triggerModel.id = value.cindex
    // console.info('serial=' + value.serial)
    state.triggerModel.column = value.column
    state.triggerModel.serial = state.triggerDeviceModel.serial
    state.triggerModel.dataitem = state.triggerDeviceModel.dataitem
    state.triggerModel.title = state.triggerDeviceModel.title
  },
  Trigger_Edit_Model: (state, value) => {
    state.triggerModel.column = value.Trigger.column
    state.triggerModel.item = value.Trigger.item + ''
    state.triggerModel.value = value.Trigger.value + ''
    state.triggerModel.aid = value.Trigger.aid.split(',')
    state.triggerModel.etype = value.Trigger.etype + ''
    state.triggerModel.count = value.Trigger.count + ''
    state.triggerModel.rangeweek = value.Trigger.rangeweek.split('')
    state.triggerModel.rangetime = [value.Trigger.rangestartint, value.Trigger.rangeendint]
    state.triggerModel.enabled = value.Trigger.enabled + ''
    state.triggerModel.content = value.Trigger.content
    state.triggerModel.id = value.Trigger.id

    state.triggerModel.serial = state.triggerDeviceModel.serial
    state.triggerModel.dataitem = state.triggerDeviceModel.dataitem
    state.triggerModel.title = state.triggerDeviceModel.title
  },
  Trigger_Set_Device_Model: (state, value) => {
    state.triggerDeviceModel.serial = value.serial
    state.triggerDeviceModel.dataitem = value.dataitem
    state.triggerDeviceModel.title = value.title
  }
}

/**
 * Actions
 * @type {Object}
 */
const actions = {
  /**
   * 设置配置选项
   */
  // changeVisible: async({
  //   commit
  // }, value) => {
  //   commit('CHANGE_DIALOGVISIBLE', value)
  // },
  deviceNewModel2: async({
    commit
  }, value) => {
    commit('Device_New_Model2')
  },
  deviceNewModel: async({
    commit
  }, value) => {
    commit('Device_New_Model', value)
  },
  deviceEditModel: async({
    commit
  }, value) => {
    commit('Device_Edit_Model', value)
  },
  triggerNewModel: async({
    commit
  }, value) => {
    commit('Trigger_New_Model', value)
  },
  triggerEditModel: async({
    commit
  }, value) => {
    commit('Trigger_Edit_Model', value)
  },
  triggerSetDeviceModel: async({
    commit
  }, value) => {
    commit('Trigger_Set_Device_Model', value)
  }
}

// Export module
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/libraries/store/modules/devices.js